import { UseQueryResult, useQuery } from '@tanstack/react-query'
import { HeadCircumferenceMeasurement, HeadCircumferenceMeasurementsFetchParams } from '~/interfaces'
import { fetchBabyGrowthHeadMeasurements, message } from '~/services'
import { hasObjectValue } from '~/utils'

const UNIQUE_KEY = 'babyGrowthHeadCircumference'

export const useFetchBabyGrowthHeadCircumferenceMeasurements = (
  params: HeadCircumferenceMeasurementsFetchParams
): UseQueryResult<HeadCircumferenceMeasurement[], Error> => {
  const fetcher = async (): Promise<HeadCircumferenceMeasurement[]> => {
    try {
      return await fetchBabyGrowthHeadMeasurements(params)
    } catch (error) {
      if (typeof error === 'string') throw new Error(error)
      throw new Error(message('messages.genericUnexpectedError'))
    }
  }

  const hasParams = (): boolean => hasObjectValue({ params })

  return useQuery<HeadCircumferenceMeasurement[], Error>([UNIQUE_KEY, params], async () => await fetcher(), {
    enabled: hasParams(),
    cacheTime: Infinity,
    staleTime: Infinity
  })
}
